import { useState, useCallback } from "react";
import { Form, useActionData, useLocation} from "react-router-dom";
import { Button, Input, Grid, Header, Message, Segment } from 'semantic-ui-react';

import { PATHS } from '../../paths';

function DesktopLoginView() {
  let location = useLocation();
  let params = new URLSearchParams(location.search);
  let from = params.get("from") || PATHS.ROOT;
  const [attemptedLogin, setAttemptedLogin] = useState(false);

  let actionData = useActionData() as { error: string } | undefined;

  const setFailedTimer = useCallback(() => {
    setAttemptedLogin(false);
    const timer = setTimeout(() => {
      setAttemptedLogin(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [setAttemptedLogin]);

  return (
    <>
      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
      {from.length > 1 && (<Message color='red'><p>You must log in to view the page at {from}</p></Message>)}
        <Header as='h2' color='teal' textAlign='center'>
          Log in to Joyya
        </Header>
        <Form method="post" replace>
          <input type="hidden" name="redirectTo" value={from} />
            <Segment stacked>
              <Input fluid icon='user' iconPosition='left' placeholder='Username' control='input' name='username' />
              <br />
              <Input
                fluid
                icon='lock'
                iconPosition='left'
                name='password'
                placeholder='Password'
                type='password'
              />
              <br />
              {attemptedLogin && (<Message
                error
                header='Failed login'
                content='Check your password and username and try again.'
                                  />)}
              <Button type="submit" color='teal' fluid size='large' onClick={() => {
                  // start a timer, set in 2 seconds
                  setFailedTimer()
                }}> {/* disabled={isLoggingIn}> */}
                Login
              </Button>
            </Segment>
          {actionData && actionData.error ? (
            <p style={{ color: "red" }}>{actionData.error}</p>
          ) : null}
        </Form>
        <Message>
          New to us? <a href={PATHS.SIGNUP}>Sign Up</a>
        </Message>
      </Grid.Column>
    </Grid>
    </>
  );
}

export { DesktopLoginView }
